// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import zappy from "@zappy-ride/library.react.components";
import { prepareChargers } from "./chargers";

export * from "./chargers";

zappy.PreloadsProvider.registerPresenter("chargers.presenter", prepareChargers);
